import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id C39421CD-2A2D-4D92-B59B-69D70A328DF4
 * name finance
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/finance.svg
 * tags
 * - Banking 
 * - Math 
 */
export const FinanceIcon = createSvgIcon(<><path d="M6,16.5L3,19.44V11H6M11,14.66L9.43,13.32L8,14.64V7H11M16,13L13,16V3H16M18.81,12.81L17,11H22V16L20.21,14.21L13,21.36L9.53,18.34L5.75,22H3L9.47,15.66L13,18.64" /></>, 'FinanceIcon');
export default FinanceIcon